import * as React from 'preact/compat'
import GameEditor, { GameEditorMode } from './GameEditor'
import Modal from '../Modal'

interface PropTypes {
  onClose: () => void,
  game_id: number|string|null,
  mode: GameEditorMode,
  onSuccess?: (requestInfo: {
    isRequest: boolean,
    id?: number,
    name: string,
    poster?: string
  }) => void,
  hidePushPrompt?: boolean,
}

const GameEditorModal = ({ onClose, ...GameEditorProps }: PropTypes) => {
  const modal = React.useRef<Modal>(null)

  return <Modal ref={modal} onClose={onClose} disableOutsideClose showClose mobileFullScreen>
    <GameEditor {...GameEditorProps} modal={modal} />
  </Modal>
}

export default GameEditorModal
